import { useCallback, useEffect, useState, useContext } from 'react';
import { Button, Col, Row, Form } from 'react-bootstrap';

import { useHttpUtils } from '../../Utilities/useHttpUtils';
import useAlert from '../../Alerts/useAlert';
import ConfigurationContext from '../../Contexts/ConfigurationContext';
import AdminTile from './AdminTile';

const SendFileToNifi = () => {
    const { setAlert } = useAlert();
    const { fetchDataAuthenticated } = useHttpUtils();
    const { configurationData } = useContext(ConfigurationContext);

    const [intialSiteHeader, setInitialSiteHeader] = useState(configurationData?.find(d => d.name === "SendFile.Header.SiteCode")?.value);
    const [intialUsageHeader, setIntialUsageHeader] = useState(configurationData?.find(d => d.name === "SendFile.Header.Usage")?.value);
    const [intialNifiURL, setIntialNifiURL] = useState(configurationData?.find(d => d.name === "SharedAPIM.PutLCREndPoint")?.value);

    useEffect(() => {
        if (configurationData) {
            setInitialSiteHeader(configurationData.find(d => d.name === "SendFile.Header.SiteCode")?.value);
            setIntialUsageHeader(configurationData.find(d => d.name === "SendFile.Header.Usage")?.value);
            setIntialNifiURL(configurationData.find(d => d.name === "SharedAPIM.PutLCREndPoint")?.value);
        }
    }, [configurationData]);

    const [fileRequest, setFileRequest] = useState({
        niFiURL: intialNifiURL,
        fileName: "Text.txt",
        fileContent: "Hello World",
        siteCodeHeader: intialSiteHeader,
        usageHeader: intialUsageHeader
    });

    const [error, setError] = useState();
    const [variant, setVariant] = useState();

    const sendFile = useCallback(() => {
        fetchDataAuthenticated("api/v1/admin/sendFile", "POST", JSON.stringify(fileRequest))
            .then(response => {
                if (!response.ok) {
                    return response.json().then(error => Promise.reject(error));
                }
                return response.json();
            })
            .then(data => {
                setVariant("");
                setError(null);
                setAlert("success", "File Sent Successfully", data);
            }).catch(error => {
                setVariant("danger");
                setAlert("danger", "Failed to send file", error.detail);
                setError(error.detail);
            });
    }, [fetchDataAuthenticated, fileRequest, setAlert]);

    return (
        <AdminTile
            title={"Send File to NiFi"}
            description={"Send text file to NiFi with editable headers to test connectivity, initial values for sending an LCR file"}
            variant={variant}>
            <>
                <Row className="mt-2 mb-2">
                    <Form>
                        <Form.Group>
                            <Form.Label><strong>NiFi URL</strong></Form.Label>
                            <Form.Control type="text" value={fileRequest.niFiURL} onChange={(e) => setFileRequest({ ...fileRequest, niFiUrl: e.target.value })} />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label><strong>File Name</strong></Form.Label>
                            <Form.Control type="text" value={fileRequest.fileName} onChange={(e) => setFileRequest({ ...fileRequest, fileName: e.target.value })} />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label><strong>File Content</strong></Form.Label>
                            <Form.Control type="text" value={fileRequest.fileContent} onChange={(e) => setFileRequest({ ...fileRequest, fileContent: e.target.value })} />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label><strong>Site Code Header</strong></Form.Label>
                            <Form.Control type="text" value={fileRequest.siteCodeHeader} onChange={(e) => setFileRequest({ ...fileRequest, siteCodeHeader: e.target.value })} />
                            <Form.Label><strong>Usage Header</strong></Form.Label>
                            <Form.Control type="text" value={fileRequest.usageHeader} onChange={(e) => setFileRequest({ ...fileRequest, usageHeader: e.target.value })} />
                        </Form.Group>
                    </Form>
                </Row>
                {error &&
                    <Row>
                        <Col>
                            <div>
                                {error}
                            </div>
                        </Col>
                    </Row>
                }
                <Button type="submit" className="ms-auto mt-auto" onClick={sendFile}>Send</Button>
            </>
        </AdminTile>
    );
};

export default SendFileToNifi;